// extracted by mini-css-extract-plugin
export default {"main-content":"Reports_main-content__Fffoq","buttons":"Reports_buttons__9eJU0","title-container":"Reports_title-container__0KMEv"};